import { QueryResultsAre } from '@jupiterone/jupiter-types';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles } from '@material-ui/styles';
import React, { FC } from 'react';
import SearchIcon from 'react-feather/dist/icons/search';
import SadIcon from 'react-feather/dist/icons/frown';
import HappyIcon from 'react-feather/dist/icons/smile';
import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit/src/theme/types';
import { urlLinks } from '@jupiterone/jupiter-web-toolkit';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: theme.spacing(2),
    },
    noResultsIcon: {
      marginBottom: theme.spacing(0.75),
      strokeWidth: 1.35,
      width: 32,
      height: 32,
      color: theme.palette.coolGrey[400],
    },
    noResultsTitle: {
      color: theme.palette.coolGrey[400],
      fontWeight: 'normal',
    },
    noResultsText: {
      color: theme.palette.coolGrey[400],
      marginTop: theme.spacing(0.5),
    },
    astronautImage: {
      width: '55%',
      alignSelf: 'flex-start',
      height: 'auto',
      marginBottom: theme.spacing(2),
    },
    astronautContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: theme.spacing(2),
    },
  })
);

const NoQueryResults = ({
  resultsAre,
  astronaut,
}: {
  resultsAre?: QueryResultsAre;
  astronaut?: boolean;
}) => {
  if (astronaut && !resultsAre) return <DefaultAstronaut />;
  if (!resultsAre) return <DefaultResults />;
  const Result = RESULT_COMPONENTS[resultsAre] || DefaultResults;
  return <Result />;
};
export default NoQueryResults;

const BadResults = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <SadIcon className={classes.noResultsIcon} />
      <Typography variant="h6" className={classes.noResultsTitle}>
        No results
      </Typography>
      <Typography variant="caption" className={classes.noResultsText}>
        We did not find any results, this may be a problem. Make sure the
        integrations are properly configured.
      </Typography>
    </div>
  );
};

const GoodResults = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <HappyIcon className={classes.noResultsIcon} />
      <Typography variant="h6" className={classes.noResultsTitle}>
        No results
      </Typography>
      <Typography variant="caption" className={classes.noResultsText}>
        You can breathe easy, we did not find any results indicating a gap or
        misconfiguration.
      </Typography>
    </div>
  );
};

const DefaultResults = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <SearchIcon className={classes.noResultsIcon} />
      <Typography variant="h6" className={classes.noResultsTitle}>
        No results
      </Typography>
      <Typography variant="caption" className={classes.noResultsText}>
        Try tweaking your query
      </Typography>
    </div>
  );
};

const DefaultAstronaut = () => {
  const classes = useStyles();
  return (
    <div className={classes.astronautContainer}>
      <img className={classes.astronautImage} src={urlLinks.lostSpacePerson} />
      <Typography variant="h6" className={classes.noResultsTitle}>
        No results
      </Typography>
      <Typography variant="caption" className={classes.noResultsText}>
        Try tweaking your query
      </Typography>
    </div>
  );
};

const RESULT_COMPONENTS: Record<QueryResultsAre, FC> = {
  [QueryResultsAre.GOOD]: BadResults, //This is counterintuitive but no results for a good is bad
  [QueryResultsAre.BAD]: GoodResults, //the reverse is true here
  [QueryResultsAre.INFORMATIVE]: DefaultResults,
  [QueryResultsAre.UNKNOWN]: DefaultResults,
};
